import { useState } from 'react';

const facts = [
  {
    icon: 'ri-fire-line',
    title: 'Kwade Energieën',
    text: 'Kwade energieën zijn negatieve spirituele krachten die bewust of onbewust op mensen worden gericht. Ze tasten de aura aan en veroorzaken langdurige pech, uitputting en blokkades.',
  },
  {
    icon: 'ri-skull-line',
    title: 'Spirituele Aanvallen',
    text: 'Een spirituele aanval is een gerichte energetische aanslag op je welzijn. Signalen zijn plotselinge angst, nachtmerries, sociaal isolement en onverklaarbare pech in meerdere levensgebieden.',
  },
  {
    icon: 'ri-compass-discover-line',
    title: 'Universeel Erkend',
    text: 'Het bestaan van kwaadaardige energieën is in vrijwel elke cultuur ter wereld erkend — van Latijns-Amerika tot West-Afrika, van het Midden-Oosten tot Azië.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Maximale Bescherming',
    text: 'De Evil Energy Protect formule is ontwikkeld voor zware gevallen waarbij standaard bescherming onvoldoende is. Speciaal samengesteld voor diepgewortelde kwade invloeden en herhaalblootstelling.',
  },
];

const symptoms = [
  { icon: 'ri-moon-line', label: 'Slaapproblemen & nachtmerries' },
  { icon: 'ri-emotion-unhappy-line', label: 'Aanhoudende depressie zonder reden' },
  { icon: 'ri-arrow-down-line', label: 'Plotselinge pechstreak in alles' },
  { icon: 'ri-heart-3-line', label: 'Relationele conflicten & verwijdering' },
  { icon: 'ri-brain-line', label: 'Mentale blokkades & besluiteloosheid' },
  { icon: 'ri-body-scan-line', label: 'Lichamelijke klachten zonder diagnose' },
];

export const EvilEnergyInfo = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section id="evil-energy-info" className="w-full py-16 bg-gradient-to-b from-[#0d0000] via-[#110500] to-[#0d0000] border-y border-red-500/10">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">

        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-red-400 text-xs font-semibold uppercase tracking-widest mb-3">✦ Maximale Kracht ✦</p>
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            Over{' '}
            <span className="text-transparent bg-gradient-to-r from-red-400 to-orange-400 bg-clip-text">
              Evil Energy Destroy
            </span>
          </h2>
          <p className="text-white/50 text-sm max-w-2xl mx-auto leading-relaxed">
            De Evil Energy Destroy Serie is ontwikkeld voor wie kampt met zware spirituele aanvallen, hardnekkige kwade energieën of herhaalblootstelling aan het boze oog. Zwaarder, krachtiger, diepgaander.
          </p>
        </div>

        {/* Symptom Badges */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {symptoms.map(s => (
            <div
              key={s.label}
              className="flex items-center gap-2 px-4 py-2.5 bg-[#1a0000]/80 border border-red-500/20 rounded-full"
            >
              <div className="w-5 h-5 flex items-center justify-center shrink-0">
                <i className={`${s.icon} text-red-400 text-sm`} />
              </div>
              <p className="text-red-200/70 text-xs font-medium whitespace-nowrap">{s.label}</p>
            </div>
          ))}
        </div>

        {/* Main Intro Block */}
        <div className="relative rounded-2xl overflow-hidden border border-red-500/20 mb-10">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/a689b87cbf88341af2a17b564e09c4f2.jpg"
              alt="Evil Energy Protect achtergrond"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0d0000]/97 via-[#0d0000]/85 to-[#0d0000]/55" />
          </div>
          <div className="relative z-10 p-8 lg:p-12 max-w-2xl">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-red-600/20 border border-red-500/30 shrink-0">
                <i className="ri-shield-flash-line text-red-400 text-lg" />
              </div>
              <h3 className="text-white font-bold text-xl">Wanneer gewone bescherming niet volstaat</h3>
            </div>
            <p className="text-white/65 text-sm leading-relaxed mb-4">
              Sommige spirituele aanvallen zijn te zwaar voor standaard remedies. De{' '}
              <strong className="text-red-300">Evil Energy Destroy</strong> formule is speciaal ontwikkeld
              voor situaties waarbij kwade energieën diepgeworteld zijn, al langdurig aanwezig zijn of
              bewust en herhaaldelijk op iemand worden gericht.
            </p>
            <p className="text-white/65 text-sm leading-relaxed mb-6">
              Op basis van dezelfde eeuwenoude blauw poeder-tradities, maar versterkt met krachtigere
              kruiden, essentiële oliën en rituele ingrediënten die al generaties lang worden gebruikt
              in beschermingsrituelen — speciaal voor zware gevallen.
            </p>
            <div className="flex flex-wrap gap-3">
              <div className="flex items-center gap-2 px-3 py-1.5 bg-red-600/15 border border-red-500/25 rounded-full">
                <i className="ri-check-line text-red-400 text-xs" />
                <span className="text-red-200/70 text-xs">Extra krachtige formule</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 bg-red-600/15 border border-red-500/25 rounded-full">
                <i className="ri-check-line text-red-400 text-xs" />
                <span className="text-red-200/70 text-xs">Diepgaande werking</span>
              </div>
              <div className="flex items-center gap-2 px-3 py-1.5 bg-red-600/15 border border-red-500/25 rounded-full">
                <i className="ri-check-line text-red-400 text-xs" />
                <span className="text-red-200/70 text-xs">Snel merkbaar resultaat</span>
              </div>
            </div>
          </div>
        </div>

        {/* Facts Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {facts.map(fact => (
            <div
              key={fact.title}
              className="bg-[#1a0000]/60 border border-red-500/15 rounded-2xl p-6 hover:border-red-500/35 transition-all duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-red-600/15 border border-red-500/20 mb-4">
                <i className={`${fact.icon} text-red-400 text-lg`} />
              </div>
              <h4 className="text-white font-semibold text-sm mb-2">{fact.title}</h4>
              <p className="text-white/45 text-xs leading-relaxed">{fact.text}</p>
            </div>
          ))}
        </div>

        {/* Comparison Block */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-10">
          <div className="bg-[#0a0820]/60 border border-violet-500/20 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-violet-600/15 border border-violet-500/20 shrink-0">
                <i className="ri-shield-star-line text-violet-400 text-sm" />
              </div>
              <h4 className="text-violet-300 font-semibold text-sm">Blue Protect Serie</h4>
            </div>
            <ul className="space-y-2">
              {[
                'Dagelijkse spirituele bescherming',
                'Preventieve aura-reiniging',
                'Geschikt voor beginners',
                'Licht & verfijnd van toepassing',
                'Ideaal voor kinderen & zwangere vrouwen',
              ].map(item => (
                <li key={item} className="flex items-center gap-2 text-white/50 text-xs">
                  <i className="ri-checkbox-circle-line text-violet-400 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-[#1a0000]/60 border border-red-500/20 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-600/15 border border-red-500/20 shrink-0">
                <i className="ri-shield-flash-line text-red-400 text-sm" />
              </div>
              <h4 className="text-red-300 font-semibold text-sm">Evil Energy Destroy Serie</h4>
            </div>
            <ul className="space-y-2">
              {[
                'Zware spirituele aanvallen & vloeken',
                'Diepgewortelde kwade energieën verwijderen',
                'Voor hardnekkige & herhaalde blootstelling',
                'Krachtige, intensieve formule',
                'Snel werkend bij urgente situaties',
              ].map(item => (
                <li key={item} className="flex items-center gap-2 text-white/50 text-xs">
                  <i className="ri-checkbox-circle-line text-red-400 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Expandable Deep Dive */}
        <div className="bg-[#1a0000]/60 border border-red-500/15 rounded-2xl overflow-hidden">
          <button
            onClick={() => setExpanded(!expanded)}
            className="w-full flex items-center justify-between p-6 cursor-pointer hover:bg-red-500/5 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-red-600/15 border border-red-500/20 shrink-0">
                <i className="ri-ancient-gate-line text-red-400" />
              </div>
              <span className="text-white font-semibold text-sm">Rituelen & Toepassingen van Evil Energy Destroy</span>
            </div>
            {expanded
              ? <i className="ri-arrow-up-s-line text-red-400 text-lg transition-transform" />
              : <i className="ri-arrow-down-s-line text-red-400 text-lg transition-transform" />
            }
          </button>

          {expanded && (
            <div className="px-6 pb-8 border-t border-red-500/10">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 pt-6">
                <div>
                  <h4 className="text-red-300 font-semibold text-sm mb-3 flex items-center gap-2">
                    <i className="ri-fire-line text-red-400" />
                    Hoe te Gebruiken
                  </h4>
                  <p className="text-white/55 text-xs leading-relaxed mb-4">
                    De Evil Energy Destroy producten zijn op basis van puur hing-extract (Ferula asafoetida) — het krachtigste afwerende middel in de Surinaamse en Hindoestaanse traditie. Gebruik de Zeep dagelijks, brand het Hing Poeder als wierook bij ruimtereiniging, en gebruik de Spray voor snelle bescherming zonder vuur.
                  </p>
                  <p className="text-white/55 text-xs leading-relaxed">
                    De Cologne kan worden toegevoegd aan badwater voor een diepe reiniging of gebruikt als dweelmiddel voor bescherming van de gehele woning. Voor baby&apos;s: gebruik de Baby Hing Pasta dagelijks in de haren of onder het kussen.
                  </p>
                </div>
                <div>
                  <h4 className="text-red-300 font-semibold text-sm mb-3 flex items-center gap-2">
                    <i className="ri-magic-line text-red-400" />
                    Toepassingsmethoden
                  </h4>
                  <ul className="space-y-2">
                    {[
                      'Dagelijks bad met de Evil Energy Destroy Zeep',
                      'Hing Poeder branden als reinigingswierook',
                      'Spray voor snelle ruimtebescherming zonder vuur',
                      'Hing Olie voor kaarsen & indamp schaaltjes',
                      'Cologne toevoegen aan badwater of dweelwater',
                    ].map(item => (
                      <li key={item} className="flex items-start gap-2 text-white/50 text-xs">
                        <i className="ri-checkbox-circle-line text-red-400 mt-0.5 shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-5 p-4 bg-red-600/10 border border-red-500/20 rounded-xl">
                    <p className="text-red-300 text-xs font-semibold mb-1">6 producten, 1 kerningredient</p>
                    <p className="text-white/45 text-xs leading-relaxed">
                      Elk product in de Evil Energy Destroy Serie is opgebouwd rondom puur hing-extract. Combineer de Zeep, Spray en Cologne voor een complete bescherming van lichaam, aura en woning.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </section>
  );
};
